import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export const createTask = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.task === undefined) {
        throw new Error('Missing required body: task');
    }
    const path = '/api/ws-funnel/tasks';
    const pathInternal = '/api/tasks';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.task !== undefined) {
        body = params.task;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createTask.paramsOrder = [{ type: 'body', paramName: 'task' }];
export const getPaginatedTasks = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.filter === undefined) {
        throw new Error('Missing required body: filter');
    }
    const path = '/api/ws-funnel/tasks/get';
    const pathInternal = '/api/tasks/get';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        body = params.filter;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPaginatedTasks.paramsOrder = [{ type: 'body', paramName: 'filter' }];
export const getBatchActivities = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-funnel/batch/activities';
    const pathInternal = '/api/batch/activities';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchActivities.paramsOrder = [{ type: 'parameters' }];
export const createTaskBatch = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.taskBatchForm === undefined) {
        throw new Error('Missing required body: taskBatchForm');
    }
    const path = '/api/ws-funnel/tasks/batch';
    const pathInternal = '/api/tasks/batch';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.taskBatchForm !== undefined) {
        body = params.taskBatchForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createTaskBatch.paramsOrder = [{ type: 'body', paramName: 'taskBatchForm' }];
export const getTask = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    const path = '/api/ws-funnel/tasks/{taskId}'.replace('{taskId}', params.taskId?.toString());
    const pathInternal = '/api/tasks/{taskId}'.replace('{taskId}', params.taskId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTask.paramsOrder = [{ type: 'parameters' }];
export const updateTask = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.task === undefined) {
        throw new Error('Missing required body: task');
    }
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    const path = '/api/ws-funnel/tasks/{taskId}'.replace('{taskId}', params.taskId?.toString());
    const pathInternal = '/api/tasks/{taskId}'.replace('{taskId}', params.taskId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.task !== undefined) {
        body = params.task;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateTask.paramsOrder = [{ type: 'body', paramName: 'task' }, { type: 'parameters' }];
export const archiveTask = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    if (params.outcome === undefined) {
        throw new Error('Missing required parameter: outcome');
    }
    const path = '/api/ws-funnel/tasks/{taskId}'.replace('{taskId}', params.taskId?.toString());
    const pathInternal = '/api/tasks/{taskId}'.replace('{taskId}', params.taskId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.outcome !== undefined) {
        urlParams.append('outcome', params.outcome.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
archiveTask.paramsOrder = [{ type: 'parameters' }];
export const archiveTasks = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.taskIds === undefined) {
        throw new Error('Missing required body: taskIds');
    }
    if (params.outcome === undefined) {
        throw new Error('Missing required parameter: outcome');
    }
    const path = '/api/ws-funnel/tasks/archive/bulk';
    const pathInternal = '/api/tasks/archive/bulk';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.taskIds !== undefined) {
        body = params.taskIds;
    }
    if (params.outcome !== undefined) {
        urlParams.append('outcome', params.outcome.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
archiveTasks.paramsOrder = [{ type: 'body', paramName: 'taskIds' }, { type: 'parameters' }];
export const updateTaskSnoozedTime = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    const path = '/api/ws-funnel/tasks/{taskId}/update_snoozed'.replace('{taskId}', params.taskId?.toString());
    const pathInternal = '/api/tasks/{taskId}/update_snoozed'.replace('{taskId}', params.taskId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.snoozedDate !== undefined) {
        urlParams.append('snoozedDate', params.snoozedDate.toString());
    }
    if (params.notifyUnsnoozed !== undefined) {
        urlParams.append('notifyUnsnoozed', params.notifyUnsnoozed.toString());
    }
    if (params.comment !== undefined) {
        urlParams.append('comment', params.comment.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateTaskSnoozedTime.paramsOrder = [{ type: 'parameters' }];
export const updateTasksOwnersByAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    const path = '/api/ws-funnel/tasks/update_task_owners_by_account';
    const pathInternal = '/api/tasks/update_task_owners_by_account';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.newOwnerName !== undefined) {
        urlParams.append('newOwnerName', params.newOwnerName.toString());
    }
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
updateTasksOwnersByAccount.paramsOrder = [{ type: 'parameters' }];
export const finishTask = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    if (params.outcome === undefined) {
        throw new Error('Missing required parameter: outcome');
    }
    const path = '/api/ws-funnel/tasks/{taskId}/finish'.replace('{taskId}', params.taskId?.toString());
    const pathInternal = '/api/tasks/{taskId}/finish'.replace('{taskId}', params.taskId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    if (params.outcome !== undefined) {
        urlParams.append('outcome', params.outcome.toString());
    }
    if (params.comment !== undefined) {
        urlParams.append('comment', params.comment.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
finishTask.paramsOrder = [{ type: 'parameters' }];
export const restoreTask = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    const path = '/api/ws-funnel/tasks/{taskId}/restore'.replace('{taskId}', params.taskId?.toString());
    const pathInternal = '/api/tasks/{taskId}/restore'.replace('{taskId}', params.taskId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.comment !== undefined) {
        urlParams.append('comment', params.comment.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
restoreTask.paramsOrder = [{ type: 'parameters' }];
export const restoreArchivedTask = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    const path = '/api/ws-funnel/tasks/{taskId}/archived/restore'.replace('{taskId}', params.taskId?.toString());
    const pathInternal = '/api/tasks/{taskId}/archived/restore'.replace('{taskId}', params.taskId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
restoreArchivedTask.paramsOrder = [{ type: 'parameters' }];
export const sendEmailToContact = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.emailTemplate === undefined) {
        throw new Error('Missing required body: emailTemplate');
    }
    const path = '/api/ws-funnel/activities/email';
    const pathInternal = '/api/activities/email';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.taskId !== undefined) {
        urlParams.append('taskId', params.taskId.toString());
    }
    if (params.emailTemplate !== undefined) {
        body = params.emailTemplate;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
sendEmailToContact.paramsOrder = [{ type: 'body', paramName: 'emailTemplate' }, { type: 'parameters' }];
export const assignTask = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    if (params.assigneeId === undefined) {
        throw new Error('Missing required parameter: assigneeId');
    }
    const path = '/api/ws-funnel/tasks/{taskId}/assign/{assigneeId}'
        .replace('{taskId}', params.taskId?.toString())
        .replace('{assigneeId}', params.assigneeId?.toString());
    const pathInternal = '/api/tasks/{taskId}/assign/{assigneeId}'
        .replace('{taskId}', params.taskId?.toString())
        .replace('{assigneeId}', params.assigneeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
assignTask.paramsOrder = [{ type: 'parameters' }];
export const assignTasks = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.taskIds === undefined) {
        throw new Error('Missing required body: taskIds');
    }
    if (params.assigneeId === undefined) {
        throw new Error('Missing required parameter: assigneeId');
    }
    const path = '/api/ws-funnel/tasks/assign/{assigneeId}/bulk'.replace('{assigneeId}', params.assigneeId?.toString());
    const pathInternal = '/api/tasks/assign/{assigneeId}/bulk'.replace('{assigneeId}', params.assigneeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.taskIds !== undefined) {
        body = params.taskIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
assignTasks.paramsOrder = [{ type: 'body', paramName: 'taskIds' }, { type: 'parameters' }];
export const updateLastCommentTime = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    const path = '/api/ws-funnel/tasks/{taskId}/update-last-comment'.replace('{taskId}', params.taskId?.toString());
    const pathInternal = '/api/tasks/{taskId}/update-last-comment'.replace('{taskId}', params.taskId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
updateLastCommentTime.paramsOrder = [{ type: 'parameters' }];
export const removeLabel = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    if (params.labelId === undefined) {
        throw new Error('Missing required parameter: labelId');
    }
    const path = '/api/ws-funnel/tasks/{taskId}/labels/{labelId}'
        .replace('{taskId}', params.taskId?.toString())
        .replace('{labelId}', params.labelId?.toString());
    const pathInternal = '/api/tasks/{taskId}/labels/{labelId}'
        .replace('{taskId}', params.taskId?.toString())
        .replace('{labelId}', params.labelId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
removeLabel.paramsOrder = [{ type: 'parameters' }];
export const getTaskContacts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    const path = '/api/ws-funnel/tasks/{taskId}/contacts'.replace('{taskId}', params.taskId?.toString());
    const pathInternal = '/api/tasks/{taskId}/contacts'.replace('{taskId}', params.taskId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTaskContacts.paramsOrder = [{ type: 'parameters' }];
export const addContactAsDefault = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    if (params.contactId === undefined) {
        throw new Error('Missing required parameter: contactId');
    }
    const path = '/api/ws-funnel/tasks/{taskId}/contacts'.replace('{taskId}', params.taskId?.toString());
    const pathInternal = '/api/tasks/{taskId}/contacts'.replace('{taskId}', params.taskId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.contactId !== undefined) {
        urlParams.append('contactId', params.contactId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addContactAsDefault.paramsOrder = [{ type: 'parameters' }];
export const removeTaskContactFromDefault = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    if (params.contactId === undefined) {
        throw new Error('Missing required parameter: contactId');
    }
    const path = '/api/ws-funnel/tasks/{taskId}/contacts'.replace('{taskId}', params.taskId?.toString());
    const pathInternal = '/api/tasks/{taskId}/contacts'.replace('{taskId}', params.taskId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.contactId !== undefined) {
        urlParams.append('contactId', params.contactId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
removeTaskContactFromDefault.paramsOrder = [{ type: 'parameters' }];
export const getStatuses = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-funnel/tasks/statuses';
    const pathInternal = '/api/tasks/statuses';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getStatuses.paramsOrder = [];
export const getSalesPersons = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-funnel/users/sales';
    const pathInternal = '/api/users/sales';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.prefix !== undefined) {
        urlParams.append('prefix', params.prefix.toString());
    }
    if (params.includeInactive !== undefined) {
        urlParams.append('includeInactive', params.includeInactive.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPersons.paramsOrder = [{ type: 'parameters' }];
export const getSources = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-funnel/sources';
    const pathInternal = '/api/sources';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.nameFilter !== undefined) {
        urlParams.append('nameFilter', params.nameFilter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSources.paramsOrder = [{ type: 'parameters' }];
export const createSource = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.source === undefined) {
        throw new Error('Missing required body: source');
    }
    const path = '/api/ws-funnel/sources';
    const pathInternal = '/api/sources';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.source !== undefined) {
        body = params.source;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createSource.paramsOrder = [{ type: 'body', paramName: 'source' }];
export const getSource = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-funnel/sources/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/sources/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSource.paramsOrder = [{ type: 'parameters' }];
export const updateSource = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.source === undefined) {
        throw new Error('Missing required body: source');
    }
    const path = '/api/ws-funnel/sources/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/sources/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.source !== undefined) {
        body = params.source;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateSource.paramsOrder = [{ type: 'body', paramName: 'source' }, { type: 'parameters' }];
export const deleteSource = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-funnel/sources/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/sources/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteSource.paramsOrder = [{ type: 'parameters' }];
export const getTaskTopics = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-funnel/tasks/topics';
    const pathInternal = '/api/tasks/topics';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.nameFilter !== undefined) {
        urlParams.append('nameFilter', params.nameFilter.toString());
    }
    if (params.includeInactive !== undefined) {
        urlParams.append('includeInactive', params.includeInactive.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTaskTopics.paramsOrder = [{ type: 'parameters' }];
export const createTaskTopic = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.taskTopic === undefined) {
        throw new Error('Missing required body: taskTopic');
    }
    const path = '/api/ws-funnel/tasks/topics';
    const pathInternal = '/api/tasks/topics';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.taskTopic !== undefined) {
        body = params.taskTopic;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createTaskTopic.paramsOrder = [{ type: 'body', paramName: 'taskTopic' }];
export const updateTaskTopic = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.taskTopic === undefined) {
        throw new Error('Missing required body: taskTopic');
    }
    const path = '/api/ws-funnel/tasks/topics/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/tasks/topics/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.taskTopic !== undefined) {
        body = params.taskTopic;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateTaskTopic.paramsOrder = [{ type: 'body', paramName: 'taskTopic' }, { type: 'parameters' }];
export const deleteTaskTopic = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-funnel/tasks/topics/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/tasks/topics/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteTaskTopic.paramsOrder = [{ type: 'parameters' }];
export const getTaskTopicsByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    const path = '/api/ws-funnel/tasks/topics/by-ids';
    const pathInternal = '/api/tasks/topics/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTaskTopicsByIds.paramsOrder = [{ type: 'body', paramName: 'ids' }];
export const getSalesfunnelLabels = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-funnel/labels/salesfunnel';
    const pathInternal = '/api/labels/salesfunnel';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.nameFilter !== undefined) {
        urlParams.append('nameFilter', params.nameFilter.toString());
    }
    if (params.includeInactive !== undefined) {
        urlParams.append('includeInactive', params.includeInactive.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesfunnelLabels.paramsOrder = [{ type: 'parameters' }];
export const updateSalesFunnelLabel = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.label === undefined) {
        throw new Error('Missing required body: label');
    }
    const path = '/api/ws-funnel/labels/salesfunnel/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/labels/salesfunnel/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.label !== undefined) {
        body = params.label;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateSalesFunnelLabel.paramsOrder = [{ type: 'body', paramName: 'label' }, { type: 'parameters' }];
export const getReportingTasks = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-funnel/reporting/tasks';
    const pathInternal = '/api/reporting/tasks';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReportingTasks.paramsOrder = [{ type: 'parameters' }];
export const createFormTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.formTemplateForm === undefined) {
        throw new Error('Missing required body: formTemplateForm');
    }
    const path = '/api/ws-funnel/form-templates';
    const pathInternal = '/api/form-templates';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.formTemplateForm !== undefined) {
        body = params.formTemplateForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createFormTemplate.paramsOrder = [{ type: 'body', paramName: 'formTemplateForm' }];
export const updateFormTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.formTemplateId === undefined) {
        throw new Error('Missing required parameter: formTemplateId');
    }
    if (params.formTemplateForm === undefined) {
        throw new Error('Missing required body: formTemplateForm');
    }
    const path = '/api/ws-funnel/form-templates/{formTemplateId}'.replace('{formTemplateId}', params.formTemplateId?.toString());
    const pathInternal = '/api/form-templates/{formTemplateId}'.replace('{formTemplateId}', params.formTemplateId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.formTemplateForm !== undefined) {
        body = params.formTemplateForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateFormTemplate.paramsOrder = [{ type: 'body', paramName: 'formTemplateForm' }, { type: 'parameters' }];
export const deleteFormTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.formTemplateId === undefined) {
        throw new Error('Missing required parameter: formTemplateId');
    }
    const path = '/api/ws-funnel/form-templates/{formTemplateId}'.replace('{formTemplateId}', params.formTemplateId?.toString());
    const pathInternal = '/api/form-templates/{formTemplateId}'.replace('{formTemplateId}', params.formTemplateId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteFormTemplate.paramsOrder = [{ type: 'parameters' }];
export const getPositionLeadReportTypes = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-funnel/form-templates/position-lead-report-types';
    const pathInternal = '/api/form-templates/position-lead-report-types';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPositionLeadReportTypes.paramsOrder = [];
export const getFormTemplateByCampaignPositionId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-funnel/campaign-positions/{campaignPositionId}/form-template'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    const pathInternal = '/api/campaign-positions/{campaignPositionId}/form-template'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getFormTemplateByCampaignPositionId.paramsOrder = [{ type: 'parameters' }];
export const downloadPositionLeadReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-funnel/campaign-positions/{campaignPositionId}/leads/download'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    const pathInternal = '/api/campaign-positions/{campaignPositionId}/leads/download'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'blob',
        requestType: 'json',
    });
};
downloadPositionLeadReport.paramsOrder = [{ type: 'parameters' }];
export const saveFormTemplateLead = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.formTemplateId === undefined) {
        throw new Error('Missing required parameter: formTemplateId');
    }
    if (params.formTemplateLeadForm === undefined) {
        throw new Error('Missing required body: formTemplateLeadForm');
    }
    const path = '/api/ws-funnel/form-templates/save-lead/{formTemplateId}'.replace('{formTemplateId}', params.formTemplateId?.toString());
    const pathInternal = '/api/form-templates/save-lead/{formTemplateId}'.replace('{formTemplateId}', params.formTemplateId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.formTemplateLeadForm !== undefined) {
        body = params.formTemplateLeadForm;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
saveFormTemplateLead.paramsOrder = [
    { type: 'body', paramName: 'formTemplateLeadForm' },
    { type: 'parameters' },
];
export const getPositionLeadsEndpoint = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.formTemplateId === undefined) {
        throw new Error('Missing required parameter: formTemplateId');
    }
    const path = '/api/ws-funnel/form-templates/{formTemplateId}/endpoint'.replace('{formTemplateId}', params.formTemplateId?.toString());
    const pathInternal = '/api/form-templates/{formTemplateId}/endpoint'.replace('{formTemplateId}', params.formTemplateId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'text/plain';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
getPositionLeadsEndpoint.paramsOrder = [{ type: 'parameters' }];
export const getSalesPromotionsTypeConfigs = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-funnel/sales-promotions/type-configs';
    const pathInternal = '/api/sales-promotions/type-configs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.searchFilter !== undefined) {
        urlParams.append('searchFilter', params.searchFilter.toString());
    }
    if (params.includeInactive !== undefined) {
        urlParams.append('includeInactive', params.includeInactive.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionsTypeConfigs.paramsOrder = [{ type: 'parameters' }];
export const createSalesPromotionsTypeConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.typeConfigForm === undefined) {
        throw new Error('Missing required body: typeConfigForm');
    }
    const path = '/api/ws-funnel/sales-promotions/type-configs';
    const pathInternal = '/api/sales-promotions/type-configs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.typeConfigForm !== undefined) {
        body = params.typeConfigForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createSalesPromotionsTypeConfig.paramsOrder = [{ type: 'body', paramName: 'typeConfigForm' }];
export const getPromotionByName = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.name === undefined) {
        throw new Error('Missing required parameter: name');
    }
    const path = '/api/ws-funnel/sales-promotions/by-name';
    const pathInternal = '/api/sales-promotions/by-name';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.name !== undefined) {
        urlParams.append('name', params.name.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPromotionByName.paramsOrder = [{ type: 'parameters' }];
export const getSalesContacts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-funnel/contacts/sales';
    const pathInternal = '/api/contacts/sales';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.includeInactive !== undefined) {
        urlParams.append('includeInactive', params.includeInactive.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesContacts.paramsOrder = [{ type: 'parameters' }];
export const getAvailableContactsBySalesPromotion = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/contacts/{salesPromotionId}'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/contacts/{salesPromotionId}'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.includeInactive !== undefined) {
        urlParams.append('includeInactive', params.includeInactive.toString());
    }
    if (params.activeAccount !== undefined) {
        urlParams.append('activeAccount', params.activeAccount.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAvailableContactsBySalesPromotion.paramsOrder = [{ type: 'parameters' }];
export const getSalesPromotionNotExcludedContactsByAccountId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/contacts/not-excluded';
    const pathInternal = '/api/sales-promotions/contacts/not-excluded';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.salesPromotionId !== undefined) {
        urlParams.append('salesPromotionId', params.salesPromotionId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionNotExcludedContactsByAccountId.paramsOrder = [{ type: 'parameters' }];
export const getContactsExcludedTypeConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.contactId === undefined) {
        throw new Error('Missing required parameter: contactId');
    }
    const path = '/api/ws-funnel/sales-promotions/contacts/excluded-type-configs';
    const pathInternal = '/api/sales-promotions/contacts/excluded-type-configs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.contactId !== undefined) {
        urlParams.append('contactId', params.contactId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getContactsExcludedTypeConfig.paramsOrder = [{ type: 'parameters' }];
export const getTypeConfigExcludedContactIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.typeConfigId === undefined) {
        throw new Error('Missing required parameter: typeConfigId');
    }
    const path = '/api/ws-funnel/sales-promotions/type-configs/excluded-contacts';
    const pathInternal = '/api/sales-promotions/type-configs/excluded-contacts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.typeConfigId !== undefined) {
        urlParams.append('typeConfigId', params.typeConfigId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTypeConfigExcludedContactIds.paramsOrder = [{ type: 'parameters' }];
export const excludeTypeConfigsForContact = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.typeConfigIds === undefined) {
        throw new Error('Missing required body: typeConfigIds');
    }
    if (params.contactId === undefined) {
        throw new Error('Missing required parameter: contactId');
    }
    const path = '/api/ws-funnel/sales-promotions/type-configs/excluded-contacts';
    const pathInternal = '/api/sales-promotions/type-configs/excluded-contacts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.typeConfigIds !== undefined) {
        body = params.typeConfigIds;
    }
    if (params.contactId !== undefined) {
        urlParams.append('contactId', params.contactId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
excludeTypeConfigsForContact.paramsOrder = [
    { type: 'body', paramName: 'typeConfigIds' },
    { type: 'parameters' },
];
export const deleteExcludedTypeConfigsForContact = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.typeConfigIds === undefined) {
        throw new Error('Missing required body: typeConfigIds');
    }
    if (params.contactId === undefined) {
        throw new Error('Missing required parameter: contactId');
    }
    const path = '/api/ws-funnel/sales-promotions/type-configs/excluded-contacts';
    const pathInternal = '/api/sales-promotions/type-configs/excluded-contacts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.typeConfigIds !== undefined) {
        body = params.typeConfigIds;
    }
    if (params.contactId !== undefined) {
        urlParams.append('contactId', params.contactId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
deleteExcludedTypeConfigsForContact.paramsOrder = [
    { type: 'body', paramName: 'typeConfigIds' },
    { type: 'parameters' },
];
export const getSalesPromotionTypeConfigById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.typeConfigId === undefined) {
        throw new Error('Missing required parameter: typeConfigId');
    }
    const path = '/api/ws-funnel/sales-promotions/type-configs/{typeConfigId}'.replace('{typeConfigId}', params.typeConfigId?.toString());
    const pathInternal = '/api/sales-promotions/type-configs/{typeConfigId}'.replace('{typeConfigId}', params.typeConfigId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionTypeConfigById.paramsOrder = [{ type: 'parameters' }];
export const updateSalesPromotionTypeConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.typeConfigId === undefined) {
        throw new Error('Missing required parameter: typeConfigId');
    }
    if (params.typeConfigForm === undefined) {
        throw new Error('Missing required body: typeConfigForm');
    }
    const path = '/api/ws-funnel/sales-promotions/type-configs/{typeConfigId}'.replace('{typeConfigId}', params.typeConfigId?.toString());
    const pathInternal = '/api/sales-promotions/type-configs/{typeConfigId}'.replace('{typeConfigId}', params.typeConfigId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.typeConfigForm !== undefined) {
        body = params.typeConfigForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateSalesPromotionTypeConfig.paramsOrder = [
    { type: 'body', paramName: 'typeConfigForm' },
    { type: 'parameters' },
];
export const deleteSalesPromotionTypeConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.typeConfigId === undefined) {
        throw new Error('Missing required parameter: typeConfigId');
    }
    const path = '/api/ws-funnel/sales-promotions/type-configs/{typeConfigId}'.replace('{typeConfigId}', params.typeConfigId?.toString());
    const pathInternal = '/api/sales-promotions/type-configs/{typeConfigId}'.replace('{typeConfigId}', params.typeConfigId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteSalesPromotionTypeConfig.paramsOrder = [{ type: 'parameters' }];
export const getSalesPromotions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.filter === undefined) {
        throw new Error('Missing required body: filter');
    }
    const path = '/api/ws-funnel/sales-promotions/get';
    const pathInternal = '/api/sales-promotions/get';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        body = params.filter;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotions.paramsOrder = [{ type: 'body', paramName: 'filter' }];
export const createSalesPromotion = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionForm === undefined) {
        throw new Error('Missing required body: salesPromotionForm');
    }
    const path = '/api/ws-funnel/sales-promotions';
    const pathInternal = '/api/sales-promotions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.salesPromotionForm !== undefined) {
        body = params.salesPromotionForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createSalesPromotion.paramsOrder = [{ type: 'body', paramName: 'salesPromotionForm' }];
export const getSalesPromotionById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionById.paramsOrder = [{ type: 'parameters' }];
export const updateSalesPromotion = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    if (params.salesPromotionForm === undefined) {
        throw new Error('Missing required body: salesPromotionForm');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.salesPromotionForm !== undefined) {
        body = params.salesPromotionForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateSalesPromotion.paramsOrder = [{ type: 'body', paramName: 'salesPromotionForm' }, { type: 'parameters' }];
export const sendPromotionContactEmails = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    if (params.mailForm === undefined) {
        throw new Error('Missing required body: mailForm');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/contacts/send-emails'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/contacts/send-emails'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.mailForm !== undefined) {
        body = params.mailForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
sendPromotionContactEmails.paramsOrder = [{ type: 'body', paramName: 'mailForm' }, { type: 'parameters' }];
export const uploadMailTemplateAttachments = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.attachmentFiles === undefined) {
        throw new Error('Missing required body: attachmentFiles');
    }
    const path = '/api/ws-funnel/sales-promotions/mail-template/attachments';
    const pathInternal = '/api/sales-promotions/mail-template/attachments';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.attachmentFiles !== undefined) {
        body = params.attachmentFiles;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
uploadMailTemplateAttachments.paramsOrder = [{ type: 'body', paramName: 'attachmentFiles' }];
export const createMailTemplateAttachments = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.attachmentForms === undefined) {
        throw new Error('Missing required body: attachmentForms');
    }
    const path = '/api/ws-funnel/sales-promotions/mail-template/attachments/create';
    const pathInternal = '/api/sales-promotions/mail-template/attachments/create';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.attachmentForms !== undefined) {
        body = params.attachmentForms;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createMailTemplateAttachments.paramsOrder = [{ type: 'body', paramName: 'attachmentForms' }];
export const getMailTemplateByPromotionId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/mail-template'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/mail-template'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getMailTemplateByPromotionId.paramsOrder = [{ type: 'parameters' }];
export const upsertMailTemplateByPromotionId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    if (params.mailTemplate === undefined) {
        throw new Error('Missing required body: mailTemplate');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/mail-template'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/mail-template'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.mailTemplate !== undefined) {
        body = params.mailTemplate;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
upsertMailTemplateByPromotionId.paramsOrder = [
    { type: 'body', paramName: 'mailTemplate' },
    { type: 'parameters' },
];
export const deleteMailTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/mail-template'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/mail-template'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteMailTemplate.paramsOrder = [{ type: 'parameters' }];
export const getSalesPromotionByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionIds === undefined) {
        throw new Error('Missing required body: salesPromotionIds');
    }
    const path = '/api/ws-funnel/sales-promotions/by-ids';
    const pathInternal = '/api/sales-promotions/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.salesPromotionIds !== undefined) {
        body = params.salesPromotionIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionByIds.paramsOrder = [{ type: 'body', paramName: 'salesPromotionIds' }];
export const getSalesPromotionShortByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionIds === undefined) {
        throw new Error('Missing required body: salesPromotionIds');
    }
    const path = '/api/ws-funnel/sales-promotions/short/by-ids';
    const pathInternal = '/api/sales-promotions/short/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.salesPromotionIds !== undefined) {
        body = params.salesPromotionIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionShortByIds.paramsOrder = [{ type: 'body', paramName: 'salesPromotionIds' }];
export const getAttachmentContentById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.attachmentId === undefined) {
        throw new Error('Missing required parameter: attachmentId');
    }
    const path = '/api/ws-funnel/mail-template/attachments/{attachmentId}'.replace('{attachmentId}', params.attachmentId?.toString());
    const pathInternal = '/api/mail-template/attachments/{attachmentId}'.replace('{attachmentId}', params.attachmentId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAttachmentContentById.paramsOrder = [{ type: 'parameters' }];
export const getAttachmentById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.attachmentId === undefined) {
        throw new Error('Missing required parameter: attachmentId');
    }
    const path = '/api/ws-funnel/attachments/{attachmentId}'.replace('{attachmentId}', params.attachmentId?.toString());
    const pathInternal = '/api/attachments/{attachmentId}'.replace('{attachmentId}', params.attachmentId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAttachmentById.paramsOrder = [{ type: 'parameters' }];
export const getBatchAttachmentsWithoutFile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.size === undefined) {
        throw new Error('Missing required parameter: size');
    }
    const path = '/api/ws-funnel/attachments/batch';
    const pathInternal = '/api/attachments/batch';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.size !== undefined) {
        urlParams.append('size', params.size.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchAttachmentsWithoutFile.paramsOrder = [{ type: 'parameters' }];
export const batchUpdateFileIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.body === undefined) {
        throw new Error('Missing required body: body');
    }
    const path = '/api/ws-funnel/attachments/batch';
    const pathInternal = '/api/attachments/batch';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.body !== undefined) {
        body = params.body;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
batchUpdateFileIds.paramsOrder = [{ type: 'body', paramName: 'body' }];
export const getSalesPromotionCampaigns = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/campaigns'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/campaigns'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.phase !== undefined) {
        urlParams.append('phase', params.phase.toString());
    }
    if (params.searchQuery !== undefined) {
        urlParams.append('searchQuery', params.searchQuery.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionCampaigns.paramsOrder = [{ type: 'parameters' }];
export const addSalesPromotionAccounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    if (params.accountForms === undefined) {
        throw new Error('Missing required body: accountForms');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/accounts/add'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/accounts/add'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountForms !== undefined) {
        body = params.accountForms;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addSalesPromotionAccounts.paramsOrder = [{ type: 'body', paramName: 'accountForms' }, { type: 'parameters' }];
export const getSalesPromotionAccountOwners = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/accounts/owners'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/accounts/owners'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.searchFilter !== undefined) {
        urlParams.append('searchFilter', params.searchFilter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionAccountOwners.paramsOrder = [{ type: 'parameters' }];
export const getSalesPromotionAccounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/accounts'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/accounts'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.taskStatus !== undefined) {
        urlParams.append('taskStatus', params.taskStatus.toString());
    }
    if (params.owner !== undefined) {
        urlParams.append('owner', params.owner.toString());
    }
    if (params.searchFilter !== undefined) {
        urlParams.append('searchFilter', params.searchFilter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionAccounts.paramsOrder = [{ type: 'parameters' }];
export const getSalesPromotionAccountsByAccountIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.accountIds === undefined) {
        throw new Error('Missing required body: accountIds');
    }
    const path = '/api/ws-funnel/sales-promotions/by-acccount-ids/get';
    const pathInternal = '/api/sales-promotions/by-acccount-ids/get';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountIds !== undefined) {
        body = params.accountIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionAccountsByAccountIds.paramsOrder = [{ type: 'body', paramName: 'accountIds' }];
export const removeSalesPromotionAccounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    if (params.accountIds === undefined) {
        throw new Error('Missing required body: accountIds');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/accounts/remove'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/accounts/remove'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountIds !== undefined) {
        body = params.accountIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
removeSalesPromotionAccounts.paramsOrder = [{ type: 'body', paramName: 'accountIds' }, { type: 'parameters' }];
export const getSalesPromotionContacts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/contacts'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/contacts'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.hasMailingTime !== undefined) {
        urlParams.append('hasMailingTime', params.hasMailingTime.toString());
    }
    if (params.gender !== undefined) {
        urlParams.append('gender', params.gender.toString());
    }
    if (params.isFormalFormOfCommunication !== undefined) {
        urlParams.append('isFormalFormOfCommunication', params.isFormalFormOfCommunication.toString());
    }
    if (params.isBounced !== undefined) {
        urlParams.append('isBounced', params.isBounced.toString());
    }
    if (params.createdByUserId !== undefined) {
        urlParams.append('createdByUserId', params.createdByUserId.toString());
    }
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.addedByUserId !== undefined) {
        urlParams.append('addedByUserId', params.addedByUserId.toString());
    }
    if (params.status !== undefined) {
        urlParams.append('status', params.status.toString());
    }
    if (params.ownerId !== undefined) {
        urlParams.append('ownerId', params.ownerId.toString());
    }
    if (params.searchFilter !== undefined) {
        urlParams.append('searchFilter', params.searchFilter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionContacts.paramsOrder = [{ type: 'parameters' }];
export const getSalesPromotionContactStatuses = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/contacts/statuses'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/contacts/statuses'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.searchFilter !== undefined) {
        urlParams.append('searchFilter', params.searchFilter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionContactStatuses.paramsOrder = [{ type: 'parameters' }];
export const getSalesPromotionContactCreatedBy = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/contacts/created-by'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/contacts/created-by'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.searchFilter !== undefined) {
        urlParams.append('searchFilter', params.searchFilter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionContactCreatedBy.paramsOrder = [{ type: 'parameters' }];
export const getSalesPromotionContactAddedBy = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/contacts/added-by'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/contacts/added-by'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.searchFilter !== undefined) {
        urlParams.append('searchFilter', params.searchFilter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionContactAddedBy.paramsOrder = [{ type: 'parameters' }];
export const getSalesPromotionContactOwners = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/contacts/owners'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/contacts/owners'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.searchFilter !== undefined) {
        urlParams.append('searchFilter', params.searchFilter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionContactOwners.paramsOrder = [{ type: 'parameters' }];
export const getSalesPromotionContactsByContactIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.contactIds === undefined) {
        throw new Error('Missing required body: contactIds');
    }
    const path = '/api/ws-funnel/sales-promotions/by-contact-ids/get';
    const pathInternal = '/api/sales-promotions/by-contact-ids/get';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.contactIds !== undefined) {
        body = params.contactIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionContactsByContactIds.paramsOrder = [{ type: 'body', paramName: 'contactIds' }];
export const addSalesPromotionContacts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    if (params.contactForms === undefined) {
        throw new Error('Missing required body: contactForms');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/contacts/add'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/contacts/add'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.contactForms !== undefined) {
        body = params.contactForms;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addSalesPromotionContacts.paramsOrder = [{ type: 'body', paramName: 'contactForms' }, { type: 'parameters' }];
export const updateSalesPromotionContactStatuses = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    if (params.contactIds === undefined) {
        throw new Error('Missing required body: contactIds');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/contacts/status'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/contacts/status'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.status !== undefined) {
        urlParams.append('status', params.status.toString());
    }
    if (params.contactIds !== undefined) {
        body = params.contactIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateSalesPromotionContactStatuses.paramsOrder = [
    { type: 'body', paramName: 'contactIds' },
    { type: 'parameters' },
];
export const removeSalesPromotionContacts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    if (params.contactIds === undefined) {
        throw new Error('Missing required body: contactIds');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/contacts/remove'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/contacts/remove'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.contactIds !== undefined) {
        body = params.contactIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
removeSalesPromotionContacts.paramsOrder = [{ type: 'body', paramName: 'contactIds' }, { type: 'parameters' }];
export const cloneSalesPromotion = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/clone'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/clone'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
cloneSalesPromotion.paramsOrder = [{ type: 'parameters' }];
export const replaceAccountId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.newAccountId === undefined) {
        throw new Error('Missing required parameter: newAccountId');
    }
    const path = '/api/ws-funnel/accounts/replace-account-id';
    const pathInternal = '/api/accounts/replace-account-id';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.newAccountId !== undefined) {
        urlParams.append('newAccountId', params.newAccountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
replaceAccountId.paramsOrder = [{ type: 'parameters' }];
export const downloadPromotionReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/report/download'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/report/download'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.type !== undefined) {
        urlParams.append('type', params.type.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'blob',
        requestType: 'json',
    });
};
downloadPromotionReport.paramsOrder = [{ type: 'parameters' }];
export const markTaskTopicActive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.isActive === undefined) {
        throw new Error('Missing required parameter: isActive');
    }
    const path = '/api/ws-funnel/tasks/topics/{id}/mark/active'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/tasks/topics/{id}/mark/active'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.isActive !== undefined) {
        urlParams.append('isActive', params.isActive.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
markTaskTopicActive.paramsOrder = [{ type: 'parameters' }];
export const getComments = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-funnel/comments';
    const pathInternal = '/api/comments';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.taskId !== undefined) {
        urlParams.append('taskId', params.taskId.toString());
    }
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.contactId !== undefined) {
        urlParams.append('contactId', params.contactId.toString());
    }
    if (params.creatorId !== undefined) {
        urlParams.append('creatorId', params.creatorId.toString());
    }
    if (params.dateFrom !== undefined) {
        urlParams.append('dateFrom', params.dateFrom.toString());
    }
    if (params.dateTo !== undefined) {
        urlParams.append('dateTo', params.dateTo.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getComments.paramsOrder = [{ type: 'parameters' }];
export const createComment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.comment === undefined) {
        throw new Error('Missing required body: comment');
    }
    const path = '/api/ws-funnel/comments';
    const pathInternal = '/api/comments';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.comment !== undefined) {
        body = params.comment;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createComment.paramsOrder = [{ type: 'body', paramName: 'comment' }];
export const updateComment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.commentId === undefined) {
        throw new Error('Missing required parameter: commentId');
    }
    if (params.comment === undefined) {
        throw new Error('Missing required body: comment');
    }
    const path = '/api/ws-funnel/comments/{commentId}'.replace('{commentId}', params.commentId?.toString());
    const pathInternal = '/api/comments/{commentId}'.replace('{commentId}', params.commentId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.comment !== undefined) {
        body = params.comment;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateComment.paramsOrder = [{ type: 'body', paramName: 'comment' }, { type: 'parameters' }];
export const deleteComment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.commentId === undefined) {
        throw new Error('Missing required parameter: commentId');
    }
    const path = '/api/ws-funnel/comments/{commentId}'.replace('{commentId}', params.commentId?.toString());
    const pathInternal = '/api/comments/{commentId}'.replace('{commentId}', params.commentId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteComment.paramsOrder = [{ type: 'parameters' }];
export const getAccountList = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-funnel/accounts';
    const pathInternal = '/api/accounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.prefix !== undefined) {
        urlParams.append('prefix', params.prefix.toString());
    }
    if (params.includeInactive !== undefined) {
        urlParams.append('includeInactive', params.includeInactive.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAccountList.paramsOrder = [{ type: 'parameters' }];
export * from './types';
export * from './constants';
